// components/ImageFileInput.tsx
// type Props = {
//     onFilesChange(files: File[]): void;
//   };
import { useRef } from "react";
import { Button } from "react-materialize";

const ImageFileInput = ({ addon, handleEvents }) => {
  const hiddenFileInput = useRef(null);
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  return (
    <>
      <Button
        className=""
        id="btn-upload-photo"
        node="button"
        waves="light"
        onClick={handleClick}
      >
        Upload
      </Button>
      <input
        type="file"
        name="photo"
        accept=".jpg, .jpeg, .png" // only accept image file types
        multiple={addon?.multiple ?? false} // allow multiple images
        onChange={handleEvents.OnChange}
        style={{ display: "none" }}
        className=""
        ref={hiddenFileInput}
      />
    </>
  );
};
export default ImageFileInput;
